import { render } from "./ViewSaleModal.vue?vue&type=template&id=64d42261&scoped=true"
import script from "./ViewSaleModal.vue?vue&type=script&lang=js"
export * from "./ViewSaleModal.vue?vue&type=script&lang=js"

import "./ViewSaleModal.vue?vue&type=style&index=0&id=64d42261&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d42261"]])

export default __exports__